import { Helmet } from 'react-helmet';

export interface ITabTitle {
  title: string | undefined;
}

const TabTitle = ({ title }: ITabTitle) => {
  return (
    <Helmet>
      <title>{title == undefined ? 'Wisestep | Make More Money' : title}</title>
    </Helmet>
  );
};

export default TabTitle;
